import { writable } from 'svelte/store';

export const step = writable(null);

export const stats = { 
    money: writable(30),
    rating: writable(50),
    mood: writable(0)
};

export const history = writable({});